import React from "react";
import styles from "./MatrixCryptoBanner.module.scss";
import { PUBLIC_ICON } from "../../../constants";

type MatrixCryptoBannerProps = {
  height?: number;
  logos?: string[];
};

const defaultLogos = [
  PUBLIC_ICON + "bitcoin.svg",
  PUBLIC_ICON + "ethereum.svg",
  PUBLIC_ICON + "tether.svg",
  PUBLIC_ICON + "bnb.svg",
  PUBLIC_ICON + "solana.svg",
  PUBLIC_ICON + "xrp.svg",
  PUBLIC_ICON + "spx.svg",
  PUBLIC_ICON + "nasdaq.svg",
];

export const MatrixCryptoBanner: React.FC<MatrixCryptoBannerProps> = ({
  height = 140,
  logos = defaultLogos,
}) => {
  const digitsPerColumn = 22;
  const layers = [
    { count: 25, speed: 7, scale: 1, opacity: 0.9 },
    { count: 30, speed: 10, scale: 0.85, opacity: 0.6 },
    { count: 40, speed: 14, scale: 0.7, opacity: 0.35 },
  ];
  const tokenLayers = [
    { countMultiplier: 1, speed: 1, opacity: 1, scale: 1 },
    { countMultiplier: 1.5, speed: 3, opacity: 0.75, scale: 0.9 },
  ];

  return (
      <div className={styles.matrixBanner} style={{ height }}>
        <div className={styles.matrixBanner__overlay} />
        {layers.map((layer, layerIndex) =>
          Array.from({ length: layer.count }).map((_, colIndex) => (
            <div
              key={`${layerIndex}-${colIndex}`}
              className={styles.matrixColumn}
              style={{
                left: `${(colIndex / layer.count) * 100}%`,
                animationDuration: `${layer.speed}s`,
                opacity: layer.opacity,
                transform: `scale(${layer.scale})`,
              }}
            >
              {Array.from({ length: digitsPerColumn }).map((__, digitIndex) => {
                const digit = (digitIndex + colIndex) % 2 ? "0" : "1";
                return (
                  <span
                    key={digitIndex}
                    className={styles.matrixDigit}
                    style={{ animationDelay: `${digitIndex * 0.12}s` }}
                  >
                    {digit}
                  </span>
                );
              })}
            </div>
          ))
        )}
        {tokenLayers.map((layer, layerIndex) =>
          Array.from({
            length: Math.round(logos.length * layer.countMultiplier),
          }).map((_, i) => {
            const logo = logos[i % logos.length];

            return (
              <div
                key={`${layerIndex}-${i}-${logo}`}
                className={styles.matrixToken}
                style={{
                  left: `${
                    (i / (logos.length * layer.countMultiplier)) * 100
                  }%`,
                  animationDuration: `${layer.speed}s`,
                  animationDelay: `${-(layerIndex * 3 + i * 0.8)}s`,
                  opacity: layer.opacity,
                  transform: `scale(${layer.scale})`,
                }}
              >
                <div className={styles.matrixToken__circle}>
                  <img src={logo} alt="token" />
                </div>
              </div>
            );
          })
        )}
      </div>
  );
};
